export default "__VITE_ASSET__CT2DtdWQ__"